export default "__VITE_ASSET__hVoybBZn__"